const UNIT = {
  PRICE: 'تومان',
  WIDTH: 'سانتی‌متر',
  WEIGHT: 'گرم',
  SIZE: 'پیکسل',
  PERCENT: 'درصد',
} as const;

export { UNIT };
